import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Button } from 'dibs-elements/exports/Button';

// Helpers
import { cutoffs } from '../../constants';

// Styles
import styles from './styles/LoadMore.scss';

// Tracking
import { trackEvent } from 'dibs-tracking';

const handleLoadMore = loadMoreCallback => {
    trackEvent({
        action: 'show more clicked',
        label: 'none',
        category: 'favorites',
    });
    loadMoreCallback();
};

const LoadMore = ({ itemsShown, isLoading, itemsToCut, onClick, totalItems, useSpacer }) => {
    if (!isLoading) {
        const itemsCutOff = itemsToCut ? itemsToCut : cutoffs.ADDITIONAL_ITEMS;
        const currentItemsDisplayedEl = (
            <div className={styles.itemsDisplayed}>
                Currently displaying 1 - {itemsShown} of {totalItems}
            </div>
        );

        if (totalItems < itemsCutOff) {
            return useSpacer ? <div className={styles.itemsSpacer} /> : null;
        }

        if (itemsShown >= totalItems) {
            return (
                <div className={styles.loadMore}>
                    <div className={styles.itemsDisplayed}>
                        Currently displaying 1 - {totalItems} of {totalItems}
                    </div>
                </div>
            );
        }

        return (
            <div className={styles.loadMore}>
                {currentItemsDisplayedEl}
                <div className={styles.button}>
                    <Button
                        onClick={() => handleLoadMore(onClick)}
                        dataTn="load-more-button"
                        size="medium"
                        style="secondary"
                    >
                        Load More
                    </Button>
                </div>
            </div>
        );
    }

    return null;
};

LoadMore.defaultProps = {
    isLoading: false,
    useSpacer: true,
};

LoadMore.propTypes = {
    itemsShown: PropTypes.number,
    isLoading: PropTypes.bool,
    itemsToCut: PropTypes.number,
    onClick: PropTypes.func,
    totalItems: PropTypes.number,
    useSpacer: PropTypes.bool,
};

export default LoadMore;
